import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.site-preferences')
  .factory('$settings', settingsTemplatesObjectFactory);

/* @ngInject */
function settingsTemplatesObjectFactory($bringozFactory: $bringozFactory,
                                        SettingsAPI: BringozApi) {

  function $settings(id: string) {
    return $bringozFactory(id, SettingsAPI)
  }

  return $settings
}
